import { Operation } from '@apollo/client';

function shouldBatchRequests({ operationName }: Operation) {
	return !operationBatchingBlacklist.has(operationName);
}

const operationBatchingBlacklist = new Set<string>();
operationBatchingBlacklist.add('GetUserConversations');

export { shouldBatchRequests };
